// extracted by mini-css-extract-plugin
export var baseButton = "_vn-0";
export var controlsArrowKeys = "_vn-1";
export var controlsResetButton = "_vn-2";
export var lightGameButton = "_vn-4 _vn-0";
export var playAgainButton = "_vn-5 _vn-0";
export var startGameButton = "_vn-3 _vn-0";